import type { KanbanResponse, TutorKanbanFilterParams } from '@ts-tutor-kanban/interfaces'

import { useTutorKanbanStore } from '@stores/tutor-kanban'
import { useCommonStore } from '@stores/common'

import { useAdminRoutes } from '@composables/routes/admin-route.hook'

interface ProbationApiOptions {
  params?: TutorKanbanFilterParams
  onStart?: () => void
  onSuccess?: (data: KanbanResponse) => void
  onError?: (err: unknown) => void
  onFinish?: () => void
}

export const useProbationApi = async (options?: ProbationApiOptions): Promise<KanbanResponse | null> => {
  const { $axios } = useNuxtApp()
  const commonStore = useCommonStore()
  const tutorKanbanStore = useTutorKanbanStore()

  const apiParams: Record<string, string | string[]> = {}

  if (options?.params) {
    const { params } = options

    if (params.q) apiParams.q = params.q
    if (params.categories.length) apiParams.categories = params.categories
    if (params.strict_categories !== null) apiParams.strict_categories = params.strict_categories
    if (params.paid_label.length) apiParams.paid_label = params.paid_label
    if (params.agents.length) apiParams.agents = params.agents
    if (params.reasons.length) apiParams.reasons = params.reasons
    if (params.sort_by) apiParams.sort_by = params.sort_by
    if (params.sort_direction) apiParams.sort_direction = params.sort_direction
  }

  const url = useAdminRoutes('admin.tutor-kanban.probation', apiParams)
  options?.onStart?.()
  commonStore.setLoading(true)

  try {
    const { data } = await $axios.get(url!)
    const response: KanbanResponse = data.data

    tutorKanbanStore.setTutors(response.tutors)
    tutorKanbanStore.setTutor(null)
    tutorKanbanStore.setAgents(response.agents)
    commonStore.setLoading(false)

    options?.onSuccess?.(response)

    return response
  } catch (err: unknown) {
    console.error(err)
    commonStore.setLoading(false)
    options?.onError?.(err)

    return null
  } finally {
    options?.onFinish?.()
  }
}
